<template>
    <div>
        <div class="container-fluid poli-course-header" v-if="course" :style="courseStyle(course.color)">
            <div class="container">
                <div class="row alternative-bg"
                     :style="bgLogoStyle">
                    <div class="col-xl-4 col-12 text-center">
                        <img :src="course.courseheader"
                             :style="leftLogoStyle"
                             class="max-width-100-non-xl ml-xl-n6"/>
                    </div>
                    <div class="col-xl-4 col-12 text-center">
                        <h1 class="poli-c-name mt-xl-5"
                            :style="courseTextStyle(course.textcolor ? course.textcolor : course.color_header, course.shadowcolor ?  course.shadowcolor : course.shadow_header)">
                            {{ course.course}}
                        </h1>
                        <div
                                class="poli-c-desc mt-xl-3"
                                :style="courseTextStyle(course.textcolor ? course.textcolor : course.textcolor, course.color_header ?  course.shadowcolor : course.shadow_header)"
                                v-if="course.name2"
                        >
                            {{ course.name2 }}
                        </div>
                        <div class="poli-c-lang"
                             :style="courseTextStyle(course.textcolor ? course.textcolor : course.color_language, course.shadowcolor ?  course.shadowcolor : course.shadow_language)">
                            [{{ languageText }}]
                        </div>
                        <div class="poli-c-age mt-xl-2 mb-4"
                             :style="courseTextStyle(course.textcolor ? course.textcolor : course.color_age, course.shadowcolor ?  course.shadowcolor : course.shadow_age)">
                            {{ageText}}
                        </div>
                    </div>
                    <div class="col-xl-4 col-12 text-center d-xl-inline-block d-none">
                        <img :src="course.courseheader2"
                             :style="rightLogoStyle"
                             class="max-width-100-non-xl mb-xl-n6 ml-xl-n8"/>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid video-block" v-if="course">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-12 col-xl-8">
                        <iframe width="100%" height="357" class="mt-xl-5 mb-xl-5 rounded-xl"
                                :src="ytUri(course.introvideo)" frameborder="0"
                                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                allowfullscreen></iframe>
                    </div>
                    <div class="col-12 col-xl-4 mt-xl-5 mb-xl-5" v-if="showAdditionalPackage">
                        <div v-if="course.ordered"
                             :class="['dop-pack-yellow', 'rounded-xl-7', {'activated' : activated, 'ordered' : additionalPackageOrdered}]">
                            <div class="dop-pack-name">{{ $t('dop_pack_title') }}:</div>
                            <div class="dop-pack-item">{{ $t('dop_pack_item_1') }}</div>
                            <div class="dop-pack-item">{{ $t('dop_pack_item_2') }}</div>
                            <div class="dop-pack-item">{{ $t('dop_pack_item_3') }}</div>
                            <div class="dop-pack-item">{{ $t('dop_pack_item_4') }}</div>
                            <div class="dop-pack-item">{{ $t('dop_pack_item_5') }}</div>
                            <div class="dop-pack-price"
                                 v-if="!additionalPackageOrdered && course.additional_package_price">
                                <span class="dop-pack-price-value">{{course.additional_package_price | formatPrice}}</span>
                                <span
                                        class="dop-pack-rub">{{ $t('cur') }}</span>
                                <span class="dop-pack-before" v-if="course.additional_package_price_before">{{course.additional_package_price_before | formatPrice}} {{ $t('cur') }}</span>
                            </div>
                            <div class="dop-pack-btn-line" v-if="additionalPackageOrdered">
                                <base-button
                                        class="mb-0 dop-pack-ordered-btn"
                                        @click="toAddPack"
                                >
                                    Скачать
                                </base-button>
                            </div>
                            <div class="dop-pack-btn-line" v-else>
                                <base-button
                                        :data-id="course.idcourse"
                                        data-model="course"
                                        :data-price="course.price"
                                        data-action="order"
                                        :data-label="orderButton.label"
                                        class="ma-0 dop-pack-btn"
                                        @click="order"
                                >
                                    {{ orderButton.label }}
                                </base-button>
                            </div>

                        </div>
                        <CourseSostav v-else
                                      :course="course"
                                      @order="orderCourse"
                        />
                    </div>
                    <!-- <div class="col-12 col-xl-4">
                    <base-button class="mt-xl-5 mb-xl-3 w-100 bg-gold-gradient rounded-xl">
                        Подробнее о нашем курсе
                    </base-button>
                    <base-button class="mb-xl-3 w-100 bg-blue-gradient rounded-xl">
                        Список необходимых<br>материалов для курса
                    </base-button>
                    <base-button class="mb-xl-3 w-100 bg-blue-gradient rounded-xl">
                        Наш магазин
                    </base-button>
                    <base-button class="mb-xl-3 w-100 bg-blue-gradient rounded-xl">
                        Ваш домашний учитель
                    </base-button>
                </div> -->
                </div>
            </div>
        </div>
        <div class="container-fluid units-block" v-if="course">
            <div class="container" ref="lessonsList">
                <div class="row pl-xl-0 pr-xl-0 pl-4 pr-4">
                    <div class="col-12 text-left">
                        <div class="unit-notice mt-xl-6 mb-xl-3 mt-4">{{ $t('start_to_tasks') }}</div>
                    </div>
                    <div class="col-12 mb-xl-n9 text-right">
                        <img src="poliimg/bird-unit.png" class="d-xl-block d-none mt-xl-n9 ml-xl-n5"/>
                        <img src="poliimg/bird-unit-mbile.png"
                             class="d-xl-none d-inline-block mt-xl-n9 ml-xl-n5 mt-n7 mr-n7 mb-n6"/>
                    </div>
                    <div class="col-12 mb-xl-5 mt-xl-0 mt-n6 mb-n5">
                        <div class="unit-list">{{ $t('lessons_list') }}</div>
                    </div>
                    <LessonListItem v-for="(item, index) in lessons"
                                    :key="item.idlesson"
                                    :title="item.lesson"
                                    :number-text="item.pos"
                                    :number="index + 1"
                                    :time="item.timetocomplete"
                                    :tests-count="item.testscount"
                                    :color="getColor(item)"
                                    :last-item="item.number === lessons.length"
                                    :free="item.isfree === 1"
                                    :locked="item.isLocked"
                                    @click.native="toLesson(item)"/>
                    <div class="col-12 mt-9"></div>
                </div>
            </div>
        </div>
        <modal
                :show="isOrderLockedAlert"
                @close="isOrderLockedAlert = false"
        >
            <template v-slot:header>
                <h2>{{ $t('lesson_unavailable') }}</h2>
            </template>
            <p>{{ $t('lesson_unavailable_by_order') }}</p>
            <template v-slot:footer>
                <base-button type="primary" @click="isOrderLockedAlert = false" :disabled="loading">OK</base-button>
            </template>
        </modal>

        <modal v-if="course"
               :show="isPerPartialPayLockedAlert"
               @close="isPerPartialPayLockedAlert = false"
        >
            <template v-slot:header>
                <h2>{{ $t('lesson_unavailable') }}</h2>
            </template>
            <p>{{ $t('lesson_per_partial_pay_locked') }}</p>
            <template v-slot:footer>
              <base-button type="primary" @click="toCoursePartialPay" :disabled="loading">{{ $t('go_to_payment') }}</base-button>
            </template>
        </modal>

        <modal v-if="course"
               :show="isPerDayLockedAlert"
               @close="isPerDayLockedAlert = false"
        >
            <template v-slot:header>
                <h2>{{ $t('lesson_unavailable') }}</h2>
            </template>
            <p>{{ $t('lesson_available_per_day') }}: <span class="strong-red">{{ course.lessons_per_day }}</span>.<br><br>
                {{ $t('lesson_will_be_available') }}
                <span v-if="course.lastCompletedLessonDate">{{ $t('through') }} <span class="strong-red">{{ course.lastCompletedLessonDate.timeToUnlock }}</span></span>
                <span v-else> {{ $t('through_24_hours') }}.</span>
            </p>
            <template v-slot:footer>
                <base-button type="primary" @click="isPerDayLockedAlert = false" :disabled="loading">OK</base-button>
            </template>
        </modal>

        <modal v-if="course"
               :show="isSubscriptionExpiredLocked"
               @close="isSubscriptionExpiredLocked = false"
        >
            <template v-slot:header>
                <h2>{{ $t('lesson_unavailable') }}</h2>
            </template>
            <p>{{ $t('prolong_subscription_to_access_course') }}</p>
            <template v-slot:footer>
                <base-button type="primary" @click="toTimetables" :disabled="loading">{{ $t('prolong') }}
                </base-button>
            </template>
        </modal>

        <modal v-if="course"
               :show="isLockedToFreeSubscriptionAlert"
               @close="isLockedToFreeSubscriptionAlert = false"
        >
            <template v-slot:header>
                <h2>{{ $t('lesson_unavailable') }}</h2>
            </template>
            <p>{{ $t('prolong_subscription_notice') }}</p>
            <template v-slot:footer>
                <base-button type="primary" @click="toTimetables" :disabled="loading">{{ $t('prolong') }}
                </base-button>
            </template>
        </modal>

        <modal v-if="course"
               :show="isLockedByPartialPayDebt"
               @close="isLockedByPartialPayDebt = false"
        >
            <template v-slot:header>
                <h2>{{ $t('lesson_unavailable') }}</h2>
            </template>
            <p>{{ $t('locked_by_partial_pay_debt') }}</p>
            <template v-slot:footer>
                <base-button type="primary" @click="toCoursePartialPay" :disabled="loading">{{ $t('go_to_payment') }}
                </base-button>
            </template>
        </modal>

    </div>
</template>
<style src="@/assets/poliglotiki/main.css">
</style>
<style>

    .strong-red {
        font-family: Manrope Bold;
        color: #ed1c24;
    }

    .course-set {
        background-color: white;
        box-shadow: 2px 2px 6px 1px #0003;
    }

    .zapis a, .zapis .btn {
        background: #ed1c24;
        padding: 10px 15px;
        min-width: 150px;
        border-radius: 18px;
        color: #fff;
        font-family: Manrope Bold;
        font-size: 18px;
        text-shadow: 1px 2px 1px rgba(0, 0, 0, 0.75);
        box-shadow: 1px 1px 3px 0 rgba(40, 40, 40, 1);
        border: none;
    }

    .cena {
        color: #231c37;
        font-size: 30px;
        font-family: Manrope Bold;
    }

    .rub {
        color: #4f4d5c;
        font-size: 16px;
        margin-left: 5px;
    }

    @media (max-width: 1199.98px) {
        .alternative-bg {
            background: none !important;
        }
    }

</style>
<script>
    import LessonListItem from "./LessonListItem";
    import courseApi from "../data/CourseApi";
    import progressApi from "../data/ProgressApi";
    import lessonApi from "../data/LessonsApi";
    import userApi from "../data/jwt.service";
    import numeral from 'numeral';
    import CourseSostav from "./CourseSostav";
    import {androidOrderCourse} from "@/data/AndroidApi";

    export default {
        props: ['slug'],
        name: 'course',
        components: {LessonListItem, CourseSostav},
        data() {
            return {
                course: null,
                lessons: null,

                progress: {
                    // ...properties
                    completedLessons: [],
                    currentLesson: {
                        id: null,
                    },
                },

                error: null,
                loading: false,

                activated: true,

                metaTitle: this.$t("course_default_title"),
                metaDescription: this.$t("course_default_description"),

                isOrderLockedAlert: false,
                isPerDayLockedAlert: false,
                isPerPartialPayLockedAlert: false,
                isSubscriptionExpiredLocked: false,
                isLockedToFreeSubscriptionAlert: false,
                isLockedByPartialPayDebt: false,
            }
        },

        metaInfo() {
            return {
                title: this.metaTitle,
                meta: [
                    {vmid: 'description', name: 'description', content: this.metaDescription}
                ]
            }
        },

        mounted() {

            if (userApi.isAuthenticated()) {
                // this.progress = progressApi.fetchProgress();
                progressApi.fetchProgress()
                    .then(progress => {
                        this.progress = progress;
                    });
            }

            courseApi.fetchCourseBySlug(this.slug)
                .then(response => {
                    this.course = response
                    this.metaTitle = this.$t('course_title', {name: this.course.course})
                    this.metaDescription = this.$t('course_description', {name: this.course.course})
                    lessonApi.fetchLessons(this.course.idcourse)
                        .then(response => {
                            this.lessons = response
                        })
                        .catch(error => {
                            let data = error.response.data
                            this.error = this.pretty(data)
                            this.loading = false
                        })
                })
                .catch(error => {
                    let data = error.response.data
                    this.error = this.pretty(data)
                    this.loading = false
                    if (error.response.status === 404 || error.response.status === 403) {
                        window.location.href = "/404"
                    }
                })


        },

        computed: {
            leftLogoStyle() {
                let style = {}
                if (this.course.courseheader_mt) style['padding-top'] = `${this.course.courseheader_mt}px`
                if (this.course.courseheader_mb) style['padding-bottom'] = `${this.course.courseheader_mb}px`
                if (this.course.courseheader_ml) style['padding-left'] = `${this.course.courseheader_ml}px`
                if (this.course.courseheader_mr) style['padding-right'] = `${this.course.courseheader_mr}px`
                return style
            },

            rightLogoStyle() {
                let style = {}
                if (this.course.courseheader2_mt) style['padding-top'] = `${this.course.courseheader2_mt}px`
                if (this.course.courseheader2_mb) style['padding-bottom'] = `${this.course.courseheader2_mb}px`
                if (this.course.courseheader2_ml) style['padding-left'] = `${this.course.courseheader2_ml}px`
                if (this.course.courseheader2_mr) style['padding-right'] = `${this.course.courseheader2_mr}px`
                return style
            },

            bgLogoStyle() {
                let style = {'background-image': null,}
                if (this.course.background) {
                    style['background-image'] = `url('${this.course.background}')`
                    style['background-repeat'] = 'no-repeat'
                    style['background-position'] = 'center center'
                }
                return style
            },

            languageText() {
                if (this.course.idlanguage) return courseApi.getLanguageName(this.course.idlanguage)
                return "-";
            },

            ageText() {
                if (this.course.ages && this.course.ages.length > 0) {
                    let ages = []
                    for (let age of this.course.ages) {
                        ages.push(courseApi.getAgeName(age.idage))
                    }
                    return ages.join(", ")
                }
                return courseApi.getAllAgeNames();
            },

            showAdditionalPackage() {
                return this.course.additional_package_enabled;
            },

            additionalPackageOrdered() {
                return this.course.additional_package_enabled
                    && this.course.isAdditionalPackage;
            },

            price() {
                if (this.course.ordered && this.course.additional_package_enabled && this.activated) return this.course.additional_package_price
                if (!this.course.ordered && this.course.additional_package_enabled && this.activated) return this.course.full_price
                return this.course.price
            },

            priceBefore() {
                if (this.course.ordered && this.course.additional_package_enabled && this.activated) return this.course.additional_package_price_before
                if (!this.course.ordered && this.course.additional_package_enabled && this.activated) return this.course.full_price_before
                return this.course.pricebefore
            },

            orderButton() {
                return {
                    label: this.$t('buy'),
                    route: `/order/${this.course.idcourse}?addonly`,
                };
            },

            goButton() {
                return {
                    label: 'Обучаться',
                    route: `/course/${this.course.slug}?add`,
                };
            },

            orderButtonText() {
                if (this.course.ordered) {
                    if (!this.course.isAdditionalPackage && this.activated && this.course.additional_package_price > 0) return this.$t('buy');
                    return this.$t('go_to');
                } else if (this.course.preorder) {
                    return this.$t('preorder');
                } else if (parseInt(this.course.price) === 0) {
                    return this.$t('subscribe');
                }
                return this.$t('buy');
            },

        },

        methods: {
            getColor(lesson) {
                if (lesson.isCompleted) return 'green'
                if (this.progress.currentLesson.id == lesson.idlesson) return 'orange'
                return 'gray'
            },
            toLesson(lesson) {
                if (this.course.restrictedByExpiredSubscription) {
                    androidOrderCourse(this.course.idcourse)
                    this.isSubscriptionExpiredLocked = true
                    return
                } else if (!lesson.isfree && this.course.restrictedByPartialPayDebt) {
                    androidOrderCourse(this.course.idcourse)
                    this.isLockedByPartialPayDebt = true
                    return
                } else if (!lesson.isfree && this.course.restrictedToFreeSubscription) {
                    androidOrderCourse(this.course.idcourse)
                    this.isLockedToFreeSubscriptionAlert = true
                    return
                } else if (lesson.isLocked) {
                    if (lesson.isOrderLocked) {
                        this.isOrderLockedAlert = true
                        return
                    }
                    if (lesson.isPerDayLocked) {
                        this.isPerDayLockedAlert = true
                        return
                    }
                    if (lesson.isPerPartialPayLocked) {
                        this.isPerPartialPayLockedAlert = true
                        return
                    }
                } else {
                    this.$router.push('/lesson/' + lesson.idlesson)
                }
            },
            ytUri(videoId) {
                return 'https://www.poliglotiki.ru/embed/' + videoId + '?controls=0'
            },
            courseStyle(color) {
                return {
                    backgroundColor: color
                }
            },

            courseTextStyle(textColor, shadowColor) {
                if (textColor && shadowColor) {
                    return {
                        color: textColor,
                        textShadow: "2px 2px " + shadowColor,
                    }
                }

                return null
            },

            pretty(value) {
                if (value.message) {
                    return value.message
                }
                return JSON.stringify(value, null, 2)
            },

            toAddPack() {
                this.$router.push('/course/' + this.course.idcourse + '/addpack')
            },

            toLessons() {
                this.$refs.lessonsList.scrollIntoView();
            },

            order() {
                this.$router.push(this.orderButton.route)
            },

            orderCourse() {
                this.$router.push(`/order/${this.course.idcourse}`)
            },

            toTimetables() {
                this.isOrderLockedAlert = false
                this.isPerDayLockedAlert = false
                this.isPerPartialPayLockedAlert = false
                this.isSubscriptionExpiredLocked = false
                this.isLockedToFreeSubscriptionAlert = false
                this.isLockedByPartialPayDebt = false
                document.body.classList.remove("modal-open");
                this.$router.push('/user/profile/timetables')
            },

            toCoursePartialPay() {
                this.isOrderLockedAlert = false
                this.isPerDayLockedAlert = false
                this.isPerPartialPayLockedAlert = false
                this.isSubscriptionExpiredLocked = false
                this.isLockedToFreeSubscriptionAlert = false
                this.isLockedByPartialPayDebt = false
                document.body.classList.remove("modal-open");
                let params = ['partial']
                this.$router.push('/payment/' + this.course.idcourse + (params.length ? ('?' + params.join('&')) : ''))
            }
        },

        filters: {
            formatPrice: function (value) {
                return numeral(value).format("0,0.00").replace(/\.0+$/,'').replace(/,/g, '\u00A0')
            }
        }
    }
</script>
